export const requiredAuthPermission = {
  JD: {
    view: 'JD_V',
    edit: 'JD_E',
    approve: 'JD_A'
  },
  CP: {
    view: 'CP_V',
    edit: 'CP_E'
  },
  Events: {
    view: 'EV_V',
    edit: 'EV_E',
    approve: 'EV_A'
  },
  Services: {
    view: 'SE_V',
    edit: 'SE_E',
    approve: 'SE_A'
  },
  Sources: {
    view: 'SE_V',
    edit: 'SE_E',
    approve: 'SE_A'
  },
  Admin: {
    view: 'AD_V',
    edit: 'AD_E'
  },
  Maintainence: {
    view: 'MNT_V',
    edit: 'MNT_E'
  },
  ANE: {
    view: 'ANE_V',
    edit: 'ANE_E'
  },
  DP: {
    view: 'DP_V',
    edit: 'DP_E'
  },
  OD: {
    view: 'OD_V'
  }
};
